import React from 'react'
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material'

import { MoveTimeStepProps } from '../types'

const MoveTimeStep: React.FC<MoveTimeStepProps> = ({ value, onChange, error }) => {
  const options = ['ASAP / This semester', 'Spring 2027', 'Fall 2027', 'Just browsing']

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        When are you planning to move into your new housing?
      </Typography>

      <FormControl error={error}>
        <RadioGroup value={value} onChange={e => onChange(e.target.value)} className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} className="text-base" />
          ))}
        </RadioGroup>
        {error && <FormHelperText>This question is required</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default MoveTimeStep
